import { ArrowUpRight, BookOpen, Microscope } from "lucide-react";
import { Link } from "react-router-dom";
import { publication, researchRole } from "../data/research";
import { SectionHeading } from "./SectionHeading";
import { SystemDiagram } from "./SystemDiagram";

export function ResearchSection() {
  return (
    <section id="research" className="section research-section">
      <div className="shell">
        <SectionHeading
          number="03"
          eyebrow="Research / publication"
          title="Perception, navigation, evidence."
          description="Research experience grounded in implementation and measured behavior."
        />
        <div className="research-grid">
          <article className="research-role panel">
            <div className="card-icon"><Microscope aria-hidden="true" /></div>
            <p className="eyebrow">Research experience</p>
            <h3>{researchRole.title}</h3>
            <p className="organization">{researchRole.institution}</p>
            <p className="meta-line">{researchRole.dates} · {researchRole.location}</p>
            <p>{researchRole.description}</p>
            <ul className="tag-list">{researchRole.areas.map((area) => <li key={area}>{area}</li>)}</ul>
          </article>
          <article className="publication-card panel">
            <div className="publication-label"><BookOpen aria-hidden="true" /> {publication.label}</div>
            <p className="eyebrow">Bachelor research</p>
            <h3>{publication.title}</h3>
            <p className="meta-line">{publication.relationship} · {publication.dates}</p>
            <p>{publication.summary}</p>
            <div className="publication-actions">
              <a href={publication.href} target="_blank" rel="noreferrer">Read publication on IEEE Xplore <ArrowUpRight aria-hidden="true" /></a>
              <Link to="/projects/lidar-navigation">Open case study <ArrowUpRight aria-hidden="true" /></Link>
            </div>
          </article>
        </div>
        <div className="research-blueprint">
          <div className="blueprint-heading">
            <span>System architecture / documented prototype</span>
            <span>signal path → action loop</span>
          </div>
          <SystemDiagram />
        </div>
      </div>
    </section>
  );
}
